export const locale = {
  lang: 'tr',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO':'Ekran görüntüsü al',
      'TOTALCOLA': 'Toplam çalışan',
      'TOTALFAL': 'Henüz yanıt vermeyen çalışanlar',
      'TOTALCONT': 'Daha önce yanıt veren çalışanlar',
      'TOTALPRO': 'Toplam ilerleme',
      'TOTALLOG': 'Anketini bitirmemiş çalışanlar',
      'REPORTE': 'İçin önerilen yanıt sayısı ...',
      'RANKING': 'İçin minimum yanıt sayısı',
      'TOOLT_REPORTE': 'Demografik sınıra göre istatistiksel olarak anlamlı sonuçların teslimi için önerilen yanıt sayısı',
      'TOOLT_RANKING': 'Şirketin Sertifikasyon / Sıralaması için minimum yanıt sayısı',

      'REPORTE_CER_CARCA':'Önerilen yanıt sayısı...',
      'TOOLT_REPORTE_CER_CARCA':'Her seçeneğin 5 yanıt alacağı dikkate alınarak, demografik kesime göre istatistiksel olarak sonuç vermek için önerilen yanıt sayısı',
      'RANKING_CER_CARCA':'Minimum yanıt sayısı...',
      'TOOLT_RANKING_CER_CARCA':'Kuruluşun Sertifikasyonu / Sıralaması için minimum yanıt sayısı',

      'REPORTE_MED_CARCA':'Önerilen yanıt sayısı...',
      'TOOLT_REPORTE_MED_CARCA':'Her seçeneğin 5 yanıt alacağı dikkate alınarak, demografik kesime göre istatistiksel olarak sonuç vermek için önerilen yanıt sayısı',
      'RANKING_MED_CARCA':'Minimum yanıt sayısı...',
      'TOOLT_RANKING_MED_CARCA':'Kuruluşun Sertifikasyonu / Sıralaması için minimum yanıt sayısı',

      'TOTALMIN': 'Minimum çalışan gerekli',
      'SELECTFPLA': 'Filtreler',
      'TBARRAPROGRESO': 'Mevcut ilerleme',
      'ACCESODENEGADO': 'Süresi dolmuş erişim bağlantısı',
      'ACCESOMSJPRE_1': 'Anketin kapanış tarihine ulaşıldı, bu portal ',
      'ACCESOMSJPRE_2': ' boyunca aktif olmaya devam edecek.',
      'BTNOK': 'TAMAM',
      'DIARESTA': 'Kalan gün',
      'NO-INFO': 'Ortak çalışanların veritabanında bilgi yok',
      'COLAB': 'Çalışanlar',
      'PORTAL_V1':'Sayma portalı V1',
      'PORTAL_V2':'Sayma portalı V2',
      'DI-TRANSCU':'İlerleme',
      'ETI_GRAFI_ZONA_HO': 'Grafikte gösterilen tarih yerel saate şu şekilde ayarlanmıştır: ',
      'ETI_FILT_V1&V2': '(*) İle işaretlenmiş gruplar, ilerlemeyi görüntülemek için gereken minimum kullanıcı sayısına sahip olmadıklarından bilgi göstermezler ',
      'WAR_RESU_ARE_MIN5': 'Alan başına sonuçları görüntülemek için minimum yanıt sayısı 5',
      'FILTROS':{
        '1': 'Ülke',
        '2': 'Konum',
        '3': 'Alan- Departman',
        '4': 'Akademik Derece',
        '5': 'Bölüm',
        '6': 'Bölüm',
         '7': 'Coğrafi Düzey 1',
         '8': 'Coğrafi Düzey 2',
         '9': 'Coğrafi Düzey 3',
         '10': 'Coğrafi Düzey 4',
         '11': 'Yapısal Seviye 1',
         '12': 'Yapısal Seviye 2',
         '13': 'Yapısal Seviye 3',
         '14': 'Coğrafi Düzey 8',
         '15': 'Coğrafi Düzey 9',
         '16': 'Coğrafi Düzey 10',
         '17': 'Hiyerarşik Düzey 1',
         '18': 'Hiyerarşik Düzey 2',
         '19': 'Hiyerarşik Düzey 3',
         '20': 'Hiyerarşik Düzey 4',
         '21': 'Hiyerarşik Düzey 5',
         '22': 'Hiyerarşik Düzey 6',
         '23': 'Hiyerarşik Düzey 7',
         '24': 'Hiyerarşik Düzey 8',
         '25': 'Hiyerarşik Düzey 9',
         '26': 'Hiyerarşik Düzey 10',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': 'Seviye 1',
        'NIVEL2': 'Seviye 2',
        'DEMOGRAFICO': 'Demografik',
        'SEGMENTO': 'Segment',
        'COLABORADORES_T': 'Toplam ortak çalışan sayısı',
        'PENDIENTES_RESPONDER': 'Henüz yanıt vermemiş ortak çalışanlar',
        'YA_RESPONDIERON': 'Zaten yanıt vermiş ortak çalışanlar',
        'AVANCE': 'Ön izleme',
        'FILTERS': 'Filtreler'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': 'Anketin uygulanmasında ilerleme: ',
        'SHEET': 'Bildiri',
        'DESCARGA': 'Portalı ',
        'MODAL_DESCARGA': 'Doğru İndirin'
      },
      'ETIQUETAS':{
        'ETIQUETAS': 'Sayfa başına öğeler',
        'OF': 'itibaren',
        'BOTON':'Filtreleri yeniden başlatın'
      },
      'FILTROS_V2':{
        'ninguno': 'Yok',
        'Company': 'şirket',
        'country': 'Ülke',
        'location': 'yer',
        'area': 'Alan',
        'antiquity': 'Kıdem',
        'generation': 'Nesil',
        'charge': 'Durum',
        'homologado': 'Pozisyon onaylandı',
        'gender': 'Cinsiyet',
        'typeofwork': 'Bir tür iş',
        'workCondition': 'Çalışma şartları',
        'academico': 'Akademik derece',
        'contratacion': 'Sözleşme Türü',
        'personal': 'Personel türü',
        'geo_1': 'Coğrafi seviye 1',
        'geo_uno': 'Coğrafi seviye 1',
        'geo_2': 'Coğrafi seviye 2',
        'geo_3': 'Coğrafi seviye 3',
        'geo_4': 'Coğrafi seviye 4',
        'geo_5': 'Coğrafi seviye 5',
        'geo_6': 'Coğrafi Seviye 6',
        'geo_7': 'Coğrafi Seviye 7',
        'geo_8': 'Coğrafi Seviye 8',
        'geo_9': 'Coğrafi Seviye 9',
        'geo_10': 'Coğrafi Seviye 10',
        'structure_1': 'Yapısal seviye 1',
        'structure_2': 'Yapısal seviye 2',
        'structure_3': 'Yapısal seviye 3',
        'structure_4': 'Yapısal seviye 4',
        'structure_5': 'Yapısal seviye 5',
        'structure_6': 'Yapısal seviye 6',
        'structure_7': 'Yapısal seviye 7',
        'structure_8': 'Yapısal seviye 8',
        'structure_9': 'Yapısal seviye 9',
        'structure_10': 'Yapısal seviye 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Yapısal seviye 1',
        'structure_DOS': 'Yapısal seviye 2',
        'structure_TRES': 'Yapısal seviye 3',
        'structure_CUATRO': 'Yapısal seviye 4',
        'structure_CINCO': 'Yapısal seviye 5',
        'structure_SEIS': 'Yapısal seviye 6',
        'structure_SIETE': 'Yapısal seviye 7',
        'structure_OCHO': 'Yapısal seviye 8',
        'structure_NUEVE': 'Yapısal seviye 9',
        'structure_DIEZ': 'Yapısal seviye 10',
        'bUnit': 'İş ünitesi',
      },
      'FILTROS_V2_HK':{
        'ninguno': 'Yok',
        'Company': 'şirket',
        'country': 'Ülke',
        'location': 'yer',
        'area': 'Alan',
        'antiquity': 'Kıdem',
        'generation': 'Nesil',
        'charge': 'Şirketteki pozisyon veya fonksiyon',
        'homologado': 'Pozisyon onaylandı',
        'gender': 'Cinsiyet',
        'typeofwork': 'Bir tür iş',
        'workCondition': 'Çalışma şartları',
        'academico': 'Akademik derece',
        'contratacion': 'Sözleşme Türü',
        'personal': 'Personel türü',
        'geo_1': 'Coğrafi seviye 1',
        'geo_uno': 'Coğrafi seviye 1',
        'geo_2': 'Coğrafi seviye 2',
        'geo_3': 'Coğrafi seviye 3',
        'geo_4': 'Coğrafi seviye 4',
        'geo_5': 'Coğrafi seviye 5',
        'geo_6': 'Coğrafi Seviye 6',
        'geo_7': 'Coğrafi Seviye 7',
        'geo_8': 'Coğrafi Seviye 8',
        'geo_9': 'Coğrafi Seviye 9',
        'geo_10': 'Coğrafi Seviye 10',
        'structure_1': 'Yapısal seviye 1',
        'structure_2': 'Yapısal seviye 2',
        'structure_3': 'Yapısal seviye 3',
        'structure_4': 'Yapısal seviye 4',
        'structure_5': 'Yapısal seviye 5',
        'structure_6': 'Yapısal seviye 6',
        'structure_7': 'Yapısal seviye 7',
        'structure_8': 'Yapısal seviye 8',
        'structure_9': 'Yapısal seviye 9',
        'structure_10': 'Yapısal seviye 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Yapısal seviye 1',
        'structure_DOS': 'Yapısal seviye 2',
        'structure_TRES': 'Yapısal seviye 3',
        'structure_CUATRO': 'Yapısal seviye 4',
        'structure_CINCO': 'Yapısal seviye 5',
        'structure_SEIS': 'Yapısal seviye 6',
        'structure_SIETE': 'Yapısal seviye 7',
        'structure_OCHO': 'Yapısal seviye 8',
        'structure_NUEVE': 'Yapısal seviye 9',
        'structure_DIEZ': 'Yapısal seviye 10',
        'bUnit': 'İş ünitesi',
      },
      'PRODUCTO':{
        'CERT': 'Onayla',
        'MED': 'Tedbir',
        'NOM35': 'Standart 035',
        'PULSE': 'Pulsecheck',
        'MEDIR_1': 'Ölçüm artırıldı',
        'MEDIR_2': 'Ölçüm + MST',
        'MEDIR_3': 'Alanlara göre ölçüm',
        'MEDIR_4': 'Liderlerin ölçümü',
        'MEDIR_5': 'Boyutlara göre ölçüm',
        'MEDIR_6': 'Onaylanacak ölçüm',
        'NAME':'şirket: ',
        'PRODUCTO':'Ürün: ',
        'PORTAL':'Sayma portalı ',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'Düzgün iş',
        'PRI_EMPLE':'İlk iş',

      },
      'EXCEL': {
        'NOMBOTON': 'Excel´i dışa aktar',
        'NOMBOTONREDUCIDO': 'Excel\'e ihracat azaldı',
        'NOMEMPRE': 'ŞİRKET ADI:',
        'NOMUSUARIO': 'KULLANICI ADI:',
        'NOMPROD': 'ÜRÜN ADI:',
        'FECHLANZA': 'BAŞLANGIÇ TARİHİ:',
        'FECHDESCA': 'İNDİRME TARİHİ:',
        'DRESTAN': 'KALAN GÜN:',
        'TOTALCOLA': 'TOPLAM ÇALIŞANLAR:',
        'TOTALCONT': 'ZATEN DESTEKLENEN ÇALIŞANLAR:',
        'TOPLAM': 'YANIT VERMEYEN ÇALIŞANLAR:',
        'TOTALPRO': 'TOPLAM İLERLEME:',
        'REPORTE': 'TESLİMATLAR İÇİN YANIT ORANI (minimum% 85):',
        'RANKING': 'SERTİFİKA VE SIRALAMA ÖRNEĞİ:',
        'FILT': 'FİLTRE:',
        'NOMFILT': 'FİLTRE ADI:',
        // pestaña müdürü
        'INFOGENE': 'Genel Rapor',
        'FILTROSNAME':{
          'gender':	'Cinsiyet',
          'typeofwork':'bir tür iş',
          'workCondition':'Çalışma koşulu',
          'academico':'Academico',
          'contratacion': 'CONTRATACIÓN',
          'personal':'kişiye özel',
          'geo_1':'coğrafi 1',
          'geo_2':'coğrafi 2',
          'geo_3':'coğrafi 3',
          'geo_4':'coğrafi 4',
          'geo_5':'coğrafi 5',
          'structure_1':'yapı 1',
          'structure_2':'yapı 2',
          'structure_3':'yapı 3',
          'structure_4':'yapı 4',
          'structure_5':'yapı 5',
          'structure_6':'yapı 6',
          'structure_7':'yapı 7',
          'structure_8':'yapı 8',
          'structure_9':'yapı 9',
          'structure_10':'yapı 10',
        }

      },
      'TIPO-PERSONAL':{
        'TIPO':'Kişisel Tür',
        '1':'Sendikasyon',
        '2':'Güven',
        '3':'Her ikisi',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'Toplam çalışan sayısı',
      'TOTALFAL': 'Henüz yanıt vermeyen çalışanlar',
      'TOTALCONT':'Daha önce yanıt vermiş olan çalışanlar',
      'TOTALPRO': 'Örnek',
      'SELECTFPLA': 'İş merkezi',
      'TBARRAPROGRESO':'Tam ilerleme',
      'TOTALLOG':'Anketini bitirmemiş çalışanlar',
      'TOTALGONE':'Cevap vermemeye karar veren kişiler',
      'FILTROS':{
        '1': "İş merkezi",
        '2': 'Ülke',
        '3': 'Konum',
        '4': 'Alan',
        '5': 'Akademik Derece',
        '6': 'Bölüm',
        '7': 'Coğrafi Düzey 1',
        '8': 'Coğrafi Düzey 2',
        '9': 'Coğrafi Düzey 3',
        '10': 'Coğrafi Düzey 4',
        '11': 'Coğrafi Düzey 5',
        '12': 'Coğrafi Düzey 6',
        '13': 'Coğrafi Düzey 7',
        '14': 'Coğrafi Düzey 8',
        '15': 'Coğrafi Düzey 9',
        '16': 'Coğrafi Düzey 10',
        '17': 'Hiyerarşik Düzey 1',
        '18': 'Hiyerarşik Düzey 2',
        '19': 'Hiyerarşik Düzey 3',
        '20': 'Hiyerarşik Düzey 4',
        '21': 'Hiyerarşik Düzey 5',
        '22': 'Hiyerarşik Düzey 6',
        '23': 'Hiyerarşik Düzey 7',
        '24': 'Hiyerarşik Düzey 8',
        '25': 'Hiyerarşik Düzey 9',
        '26': 'Hiyerarşik Düzey 10',
      }

    },
    'BTN':{
      'USERS':'işbirlikçiler'
    }
  }
};
